<div class="start-calendar">
  <mat-calendar
    id="startCalendar"
    #startCalendar
    [startAt]="startCalendarData.startDate"
    [selected]="selectedDates"
    (selectedChange)="updateDateRangeSelection($event)"
    (monthSelected)="monthSelected($event)"
    [minDate]="minDate"
    [maxDate]="maxDate"></mat-calendar>
</div>
<div class="end-calendar">
  <mat-calendar
    id="endCalendar"
    #endCalendar
    [startAt]="endCalendarData.startDate"
    [minDate]="endCalendarData.minDate"
    [maxDate]="maxDate"
    [selected]="selectedDates"
    (selectedChange)="updateDateRangeSelection($event)"
    (monthSelected)="secondViewMonthSelected($event)"></mat-calendar>
</div>
